export default "__VITE_ASSET__CSCz07j5__"